import { Button, Card, CardContent, Checkbox, CircularProgress, FormControlLabel, FormGroup, Grid, IconButton, Input, MenuItem, Select, Skeleton, Typography, useMediaQuery } from "@mui/material";
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import { borderRadius, Box, display, height, width } from "@mui/system";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
// import KanbanBoard from './components/KanbanBoard';
import { useDispatch, useSelector } from "react-redux";
import ViewToggle from './components/ViewToggle';
import OrgSelectorDropdown from './components/OrgSelectorDropdown';
import KanbanBoard from './components/KanbanBoard';
import { useFillViewportHeight } from "../../hooks/useFillViewportHeight";
import CustomCard from "../../components/CustomCard";
import AuthLayout from "../layouts/AuthLayout";
import EventCard from "./components/EventCard";
import useEventList from "./hooks/useEventList";
import luciLogo from "../../assets/luciLogo2.png";
import luciIcon from "../../assets/luci_icon.svg";
import SearchIcon from "@mui/icons-material/Search";
import useArraySearch from "./hooks/useArraySearch";
import useStatusType from "../../hooks/dropdowns/useStatusType";
import { setDropDownArray } from "../../redux/dropdownSlice";
import AddIcon from "./icons/AddIcon";
import { updateState } from "../../redux/commonSlice";
import {generateLighterContrastColor,  timeStampToString } from "../../utils/commonServices";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { readEditorParam, writeEditorParam } from "./editorFilterParams";
import { readSearchParam, useSyncSearchParam } from "../../hooks/useSearchStringParam";
import EventCreationDrawer from "../eventcreation";
import CustomUserCard from "../events/components/CustomUserCard";
import "@fontsource/rubik";
import CustomSortOptions from "../events/components/CustomSortOptions";
import filmingTutorialImage from "../../assets/filmingTutorialCard.png"
import { eventSortOptions,  sortByOptions } from "../../constants/staticData";
import useEventSort from "./hooks/useEventSort";
import useEventTypeList from "../eventcreation/hooks/useEventTypeList";
import EventFilter from "./components/EventFilter";
import CustomPopoverFilter from "./components/CustomPopoverFilter";
import PopupVideoPlayer from "../../components/PopupVideoPlayer";
import DeleteConfirmationPopup from "./components/DeleteConfirmationPopup";
import useDeleteProject from "./hooks/useDeleteProject";
import DeleteDeclinePopup from "./components/DeleteDeclinePopup";
import useFilter from "./hooks/useFilter";
import { resetReviewState, updateReviewState } from "../../redux/reviewSlice";
import { updateCreationState } from "../../redux/eventCreationSlice";
import DeclineEditProjectPopup from "./components/DeclineEditProjectPopup";
import { setAllMediaFilesArray } from "../../redux/mediaFilesSlice";
import { gaEvents } from "../../ga/actions";
import MainLogoCard from "./components/MainLogoCard";
import AllTeamsCard from "./components/AllTeamsCard";
import TeamCreationDrawer from "../teams";
import DeleteTeamPopup from "../teams/components/DeleteTeamPopup";
import RenameTeamPopup from "../teams/components/RenameTeamPopup";
import butterfly from './../../assets/butterfly_navigation.png'
import { getPermissions, getRoleNamesFromIds, getRoles, getUserRoles } from "../../commonactions/actions";
import { getAllEvents, getAllTeams, viewOrganisationMember } from "./actions";
import InviteOrganisationMembersPopup from "./components/InviteOrganisationMembersPopup";
import RemoveOrganisationMemberConfirmationPopup from "./components/RemoveOrganisationMemberConfirmationPopup";
import AssignAdminRolePopup from "./components/AssignAdminRolePopup";
import { viewProjectMembers } from "../events/actions";
import { updatePermissionState } from "../../redux/permissionSlice";
import ViewOrganisationMembersPopup from "./components/ViewOrganisationMembersPopup";
import BackdropCreateProject from "../eventcreation/components/BackdropCreateProject";
import DownIcon from "../eventcreation/icons/DownIcon";
import { PERMISSION } from "../../constants/constants";
import usePermissions from "../../hooks/usePermissions";
import { updateTeamState } from "../../redux/teamSlice";
import { setSnackbar } from "../../redux/messageSlice";
import EventTypeFilter from "./components/EventTypeFilter";
import useProjectTypeFilter from "./hooks/useProjectTypeFilter";
import useVideoLengthList from "../eventcreation/hooks/useVideoLengthList";
import { getTheme } from "../whitelabel/actions";
import {alpha,   getContrastRatio } from '@mui/material/styles';
// import { customTheme as theme } from "../../theme/customTheme";
import useCustomTheme from "../../theme/useCustomTheme";
import AllOrganizationsCard from "./components/AllOrganizationsCard";
import DrawerOrganizationList from "./components/DrawerOrganizationList";
import useDashboardActions from "./useDashboardActions";
import useCommonActions from "../../commonactions/useCommonActions";
import useOrganisationProjectActions from "../events/useOrganisationProjectActions";
import ViewProjectMembersPopup from "../events/components/ViewProjectMembersPopup";
import EditingNotStartedPopup from "./components/EditingNotStartedPopup";
import CustomTooltip from "../../components/CustomTooltip";
import { resetProjectState, updateProjectState } from "../../redux/projectSlice";
import EventStatusFilter from "./components/EventStatusFilter";
import MarkUnreadChatAltRoundedIcon from '@mui/icons-material/MarkUnreadChatAltRounded';
import BoltIcon from '@mui/icons-material/Bolt';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import StayCurrentLandscapeIcon from '@mui/icons-material/StayCurrentLandscape';
import StayCurrentPortraitIcon from '@mui/icons-material/StayCurrentPortrait';
import MovieOutlinedIcon from '@mui/icons-material/MovieOutlined';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import ChangeMemberRoleConfirmationPopup from "./components/ChangeMemberRoleConfirmationPopup";
import  {useProjectList}  from "./hooks/useProjectList";
import useDebounce from "./hooks/useDebounce";
import { useInfiniteScroll } from "./hooks/useInfiniteScroll";
import { matchesDueDateFilter } from '../../utils/dueDateUtils';
import usePendingQuickTurnActions from '../pendingquickturn/usePendingQuickTurnActions';
import PharoahVisibilityUndoSnackbar from '../../components/PharoahVisibilityUndoSnackbar';

const DUE_WITHIN_HOURS_OPTIONS = [
  { value: '',       label: 'All' },
  { value: 'overdue', label: 'Overdue' },
  { value: 6,        label: '6 hours' },
  { value: 24,       label: '24 hours' },
  { value: 72,       label: '3 days' },
  { value: 168,      label: '7 days' },
];


const DueDateFilterSelect = ({ value, onChange }) => (
  <Select
    value={value ?? ''}
    onChange={(e) => onChange(e.target.value === '' ? null : (e.target.value === 'overdue' ? 'overdue' : Number(e.target.value)))}
    size="small"
    displayEmpty
    startAdornment={<Box sx={{ display:'flex', alignItems:'center', gap: '3px', mr: 0.5 }}><EventAvailableOutlinedIcon sx={{ fontSize: { xs: '12px', md: '14px', lg: '16px', xl: '20px' }, color: value ? '#000' : '#555' }} /><Typography sx={{ fontFamily:'Rubik', fontSize:{ xs:'9px', md:'10px', lg:'11px', xl:'13px' }, color:'#555', whiteSpace:'nowrap' }}>Due:</Typography></Box>}
    sx={{
      fontFamily: 'Rubik',
      fontSize: { xs: '10px', md: '11px', lg: '12px', xl: '14px' },
      fontWeight: value ? 700 : 400,
      color: '#000',
      '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
      '& .MuiSelect-select': { py: 0.5, px: 0.5, pr: '24px !important' },
      '& .MuiSvgIcon-root': { color: '#000' },
      minWidth: { xs: '90px', lg: '110px', xl: '130px' },
    }}
    MenuProps={{ PaperProps: { sx: { borderRadius: '8px', mt: 0.5 } } }}
  >
    {DUE_WITHIN_HOURS_OPTIONS.map((opt) => (
      <MenuItem key={opt.value} value={opt.value} sx={{ fontFamily: 'Rubik', fontSize: { xs: '11px', lg: '12px', xl: '14px' }, color: '#000' }}>
        {opt.label}
      </MenuItem>
    ))}
  </Select>
);

const EventTypeFilterSelect = ({ value, onChange, eventTypes }) => (
  <Select
    value={value ?? ''}
    onChange={(e) => onChange(e.target.value === '' ? null : e.target.value)}
    size="small"
    displayEmpty
    startAdornment={<Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '9px', md: '10px', lg: '11px', xl: '13px' }, color: '#555', whiteSpace: 'nowrap', mr: 0.5 }}>Type:</Typography>}
    sx={{
      fontFamily: 'Rubik',
      fontSize: { xs: '10px', md: '11px', lg: '12px', xl: '14px' },
      fontWeight: value ? 700 : 400,
      color: '#000',
      '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
      '& .MuiSelect-select': { py: 0.5, px: 0.5, pr: '24px !important' },
      '& .MuiSvgIcon-root': { color: '#000' },
      minWidth: { xs: '90px', lg: '110px', xl: '130px' },
    }}
    MenuProps={{ PaperProps: { sx: { borderRadius: '8px', mt: 0.5 } } }}
  >
    <MenuItem value="" sx={{ fontFamily: 'Rubik', fontSize: { xs: '11px', lg: '12px', xl: '14px' }, color: '#000' }}>
      All Types
    </MenuItem>
    {(eventTypes ?? [])
      // show only types flagged visible by the API (field is spelled "visibile" server-side)
      .filter((t) => (t.visible ?? t.visibile) !== false)
      .filter((t) => t.value !== 'Wedding Moment')
      .map((t) => (
      <MenuItem key={t.id} value={t.id} sx={{ fontFamily: 'Rubik', fontSize: { xs: '11px', lg: '12px', xl: '14px' }, color: '#000' }}>
        {t.value}
      </MenuItem>
    ))}
  </Select>
);

const EditorFilterSelect = ({ value, onChange, editors }) => {
  // The editor id can arrive from the URL before organisation_members_list has loaded.
  // Without a matching MenuItem MUI renders the Select blank and warns, so hold the
  // value with a placeholder entry until the real name is available.
  const isKnown = !value || value === 'unassigned' || editors.some((e) => String(e.id) === String(value));
  return (
  <Select
    value={value}
    onChange={(e) => onChange(e.target.value)}
    size="small"
    displayEmpty
    startAdornment={<PersonSearchIcon sx={{ fontSize: { xs: '12px', md: '14px', lg: '16px', xl: '20px' }, mr: 0.5, color: value ? '#000' : '#555' }} />}
    sx={{
      fontFamily: 'Rubik',
      fontSize: { xs: '10px', md: '11px', lg: '12px', xl: '14px' },
      fontWeight: value ? 700 : 400,
      color: '#000',
      '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
      '& .MuiSelect-select': { py: 0.5, px: 0.5, pr: '24px !important' },
      '& .MuiSvgIcon-root': { color: '#000' },
      minWidth: { xs: '90px', lg: '110px', xl: '130px' },
    }}
    MenuProps={{ PaperProps: { sx: { borderRadius: '8px', mt: 0.5 } } }}
  >
    <MenuItem value="" sx={{ fontFamily: 'Rubik', fontSize: { xs: '11px', lg: '12px', xl: '14px' }, color: '#000' }}>
      All Editors
    </MenuItem>
    <MenuItem value="unassigned" sx={{ fontFamily: 'Rubik', fontSize: { xs: '11px', lg: '12px', xl: '14px' }, color: '#000', fontStyle: 'italic' }}>
      Unassigned
    </MenuItem>
    {!isKnown && <MenuItem value={value} sx={{ display: 'none' }}>Editor</MenuItem>}
    {editors.filter(e => !!e?.name).map((editor) => (
      <MenuItem key={editor.id} value={editor.id} sx={{ fontFamily: 'Rubik', fontSize: { xs: '11px', lg: '12px', xl: '14px' }, color: '#000' }}>
        {editor.name}
      </MenuItem>
    ))}
  </Select>
  );
};

// Admin-only board filter — `hidden=true` returns ONLY hidden projects on the three
// board endpoints. Gated on the Admin role rather than letting the request 403.
const HiddenFilterToggle = ({ value, onChange }) => (
  <Button
    size="small"
    onClick={() => onChange(!value)}
    data-testid="hidden-filter-toggle"
    aria-pressed={!!value}
    startIcon={<VisibilityOffOutlinedIcon sx={{ fontSize: { xs: '12px', md: '14px', lg: '16px', xl: '20px' } }} />}
    sx={{
      fontFamily: 'Rubik',
      fontSize: { xs: '10px', md: '11px', lg: '12px', xl: '14px' },
      fontWeight: value ? 700 : 400,
      textTransform: 'none',
      color: value ? '#FFFFFF' : '#555',
      backgroundColor: value ? '#5A6474' : 'transparent',
      '&:hover': { backgroundColor: value ? '#48505E' : 'rgba(0,0,0,0.06)' },
      py: 0.5,
      px: 1,
      minWidth: 'auto',
      borderRadius: '4px',
      whiteSpace: 'nowrap',
    }}
  >
    Hidden
  </Button>
);

const QuickTurnToggle = ({ value, onChange }) => (
  <Button
    size="small"
    onClick={() => onChange(!value)}
    startIcon={<BoltIcon sx={{ fontSize: { xs: '12px', md: '14px', lg: '16px', xl: '20px' } }} />}
    sx={{
      fontFamily: 'Rubik',
      fontSize: { xs: '10px', md: '11px', lg: '12px', xl: '14px' },
      fontWeight: value ? 700 : 400,
      textTransform: 'none',
      color: value ? '#08231B' : '#555',
      backgroundColor: value ? '#00D744' : 'transparent',
      border: value ? 'none' : 'none',
      '&:hover': { backgroundColor: value ? '#00c03c' : 'rgba(0,0,0,0.06)' },
      py: 0.5,
      px: 1,
      minWidth: 'auto',
      borderRadius: '4px',
      whiteSpace: 'nowrap',
    }}
  >
    Quick Turn
  </Button>
);

let counter = 0;
    
const eventStatusFilterOptions = [
    {param: 'can_upload', value: 'can_upload',label:   <Box  sx={{  width:{xs:'5%', lg:'7%'} , display:'flex', alignItems:'center',justifyContent:'center', marginRight:'4px' }} ><img src={luciIcon}  width='100%' /></Box>, text: 'Edited video needs to be uploaded' },

    {param: 'internal_revision', value: 'video_uploaded',label: <VisibilityIcon sx={{ fontSize:{xs:'12px !important',sm:'14px !important',md:'16px !important',lg:'18px !important',xl:'24px !important'},  '& .MuiSvgIcon-root':{fontSize:{xs:'12px !important',md:'14px !important',lg:'17px !important',xl:'24px !important'}}}}/>, text: 'Ready for internal review' },

    {param: 'pending', value: 'client_action',label: <FiberManualRecordIcon sx={{color:'red', fontSize:{xs:'12px !important',sm:'14px !important',md:'16px !important',lg:'18px !important',xl:'24px !important'},  '& .MuiSvgIcon-root':{fontSize:{xs:'12px !important',md:'14px !important',lg:'17px !important',xl:'24px !important'}}}}/>, text: 'Pending client review' },

    {param: 'chat', value: 'new_text', label: <MarkUnreadChatAltRoundedIcon sx={{color:'#e4d00a', fontSize:{xs:'12px !important',sm:'14px !important',md:'16px !important',lg:'18px !important',xl:'24px !important'},  '& .MuiSvgIcon-root':{fontSize:{xs:'12px !important',md:'14px !important',lg:'17px !important',xl:'24px !important'}}}}/>, text:'Revisions logged, not submitted '},

    {param: 'can_upload', value: 'editing_cycle', label: <MovieOutlinedIcon sx={{fontSize:{xs:'12px !important',sm:'14px !important',md:'16px !important',lg:'18px !important',xl:'24px !important'},  '& .MuiSvgIcon-root':{fontSize:{xs:'12px !important',md:'14px !important',lg:'17px !important',xl:'24px !important'}}}}/>, text:'Revision projects'},

    {param: 'completed', value: 'project_complete', label: <CheckCircleIcon sx={{color:'#00d744', fontSize:{xs:'12px !important',sm:'14px !important',md:'16px !important',lg:'18px !important',xl:'24px !important'},  '& .MuiSvgIcon-root':{fontSize:{xs:'12px !important',md:'14px !important',lg:'17px !important',xl:'24px !important'}}}}/>, text:'Completed projects '},

  ];


const Dashboard = () => {
    const createEventReducer = useSelector((state) => state.createEventReducer);
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
    const teamsReducer = useSelector((state) => state.root.teamsReducer);
    const permissionsReducer = useSelector((state) => state.permissionsReducer)
    const projectReducer = useSelector((state) => state.projectReducer)
    const [selectedSortbyValue, setSelectedSortbyValue] = useState(null);
      const [selectedEventStatusValue, setSelectedEventStatusValue] = useState(null)
    // const [selectedEventStatusbyValue, setSelectedEventStatusbyValue] = useState(null);
    const [searchedArray, setSearchedArray] = useState(projectReducer?.org_projects_list);
    const [searchParams, setSearchParams] = useSearchParams()
    // The search text lives in the URL alongside the filters so that leaving the board
    // for a project and coming back restores the list the user was actually looking at.
    const [searchString, setSearchString] = useState(() => readSearchParam(searchParams));
    const [deleteProject, deleteEventStatus] = useDeleteProject(commonReducer.production_event_id);
    const [selectedProjectTypeValue, setSelectedProjectTypeValue] = useState(['View All']);
    const [selectedProjectTypeIds, setSelectedProjectTypeIds] = useState([])
    const [projectTypeEvents] = useProjectTypeFilter(searchedArray, selectedProjectTypeValue);
    const [projects, setProjects] = useState([])
    const [dueWithinHours, setDueWithinHoursState] = useState(
      searchParams.get('overdue') === 'true' ? 'overdue' : null
    )
    const [selectedEventTypeId, setSelectedEventTypeId] = useState(null)
    // The editor filter lives in the URL so that leaving the board for a project and
    // coming back restores the editor's project list rather than the whole dashboard.
    // `unassigned=true` is kept as its own flag for backwards compatibility with
    // existing links; a real editor is carried as `editor=<id>`.
    const [selectedEditorId, setSelectedEditorIdState] = useState(() => readEditorParam(searchParams))
    const setDueWithinHours = useCallback((value) => {
      setDueWithinHoursState(value);
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        if (value === 'overdue') next.set('overdue', 'true');
        else next.delete('overdue');
        return next;
      }, { replace: true });
    }, [setSearchParams]);

    const setSelectedEditorId = useCallback((value) => {
      setSelectedEditorIdState(value);
      setSearchParams((prev) => writeEditorParam(prev, value), { replace: true });
    }, [setSearchParams]);

    const [quickTurn, setQuickTurn] = useState(false);
    // Admin — the role every hidden-project endpoint checks.
    const isPharoahAdmin = commonReducer?.role_name === 'Admin'
    const [hiddenOnly, setHiddenOnlyState] = useState(
      () => searchParams.get('hidden') === 'true'
    )
    const setHiddenOnly = useCallback((value) => {
      setHiddenOnlyState(value);
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        if (value) next.set('hidden', 'true');
        else next.delete('hidden');
        return next;
      }, { replace: true });
    }, [setSearchParams]);

    const isAdmin = commonReducer?.is_admin === true
    const editorList = useMemo(
      () => (commonReducer?.organisation_members_list ?? []).filter(m => (m?.role_name === 'Editor' || m?.role?.name === 'Editor') && !!m?.name),
      [commonReducer?.organisation_members_list]
    )
    const [sortedEventsRaw] = useEventSort(projects, selectedSortbyValue);
    const sortedEvents = useMemo(() => {
      if (!selectedEditorId) return sortedEventsRaw ?? [];

      if (selectedEditorId === 'unassigned') {
        return (sortedEventsRaw ?? []).filter(e => !e.editors?.length || e.editors.every(ed => ed === null));
      }

      // Before organisation_members_list resolves (e.g. landing straight on ?editor=<id>)
      // the name is unknown. Show nothing rather than the whole unfiltered board — a
      // filter is applied, and flashing every project contradicts it.
      const editorName = editorList.find(e => String(e.id) === String(selectedEditorId))?.name;
      if (!editorName) return [];

      return (sortedEventsRaw ?? []).filter(e =>
        e.editors?.some(ed => (typeof ed === 'string' ? ed : ed?.name) === editorName)
      );
    }, [sortedEventsRaw, selectedEditorId, editorList]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [eventTypes] = useEventTypeList()
    const [members, setMembers] = useState(teamsReducer.organization_members)
    const [hasPermission] = usePermissions();
    const [theme] = useCustomTheme()
    const isMobileView = useMediaQuery('(max-width:599px)');
    const [boardContainerRef, boardContainerHeight] = useFillViewportHeight(16, [isMobileView]);
    const { acceptMemberInvitation, getOrganisationMembersList} = useDashboardActions()
    const {getUserRoles, getRoles} = useCommonActions()
    const {getProjectDetails} = useOrganisationProjectActions()
    const { getQuickTurnRequests } = usePendingQuickTurnActions()
    const [selectedFlag, setSelectedFlag] = useState('')
      const [selectedOrganisation, setSelectedOrganisation] = useState(() => {
        try {
          const saved = sessionStorage.getItem('dashboard_selected_org');
          return saved ? JSON.parse(saved) : '';
        } catch {
          return '';
        }
      });

    // VIEW TOGGLE DISABLED — board view only for now. Re-enable by restoring the lines below:
    // const [view, setView] = useState(() => sessionStorage.getItem('preferred_view') || 'board');
    // const handleViewChange = useCallback((newView) => {
    //   setView(newView);
    //   sessionStorage.setItem('preferred_view', newView);
    // }, []);
    const view = 'board';
    const handleViewChange = useCallback(() => {}, []);
    // const [selectedEventStatusValue, setSelectedEventStatusValue] = useState(null)
   

  const debouncedSearch = useDebounce(searchString, 500);
  useSyncSearchParam(searchParams, setSearchParams, debouncedSearch);
  

    const {
    data,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    
  } = useProjectList({ orgId: selectedOrganisation?.id, selectedProjectTypeIds, flag: selectedFlag, name: debouncedSearch });

useEffect(() => {
  try {
    if (selectedOrganisation) {
      sessionStorage.setItem('dashboard_selected_org', JSON.stringify(selectedOrganisation));
    } else {
      sessionStorage.removeItem('dashboard_selected_org');
    }
  } catch {}
}, [selectedOrganisation]);

const observer = useRef();

const lastElementRef = useCallback(
  (node) => {
    if (isFetchingNextPage) return; // skip if a page is already being fetched
    if (observer.current) observer.current.disconnect(); // clean up old observer

    if (node) {
      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasNextPage) {
            // console.log('fetching next page!!!!!!!!!!!!!!!!!!')
            fetchNextPage(); // trigger next page fetch when last card enters viewport
          }
        },
        {
          root: document.querySelector("#events"), // scrollable container
          rootMargin: "100px", // triggers slightly before fully visible
          threshold: 0.5, // fraction of visibility
        }
      );

      observer.current.observe(node); // start observing last element
    }
  },
  [isFetchingNextPage, fetchNextPage, hasNextPage]
);



useEffect(()=>{
  const pages = data?.pages ?? [];
  const events = pages.flatMap(page => page?.data?.data?.event_details || []);
  setProjects(events)
  // console.log(events, 'eventssssssssssssssssssssssssssssssssssssssssssssss')
},[data])

// console.log(projects, 'sortedEventssssssssssssss')
//  const pages = data?.pages ?? [];
//   const events = pages.flatMap(page => page?.data?.data?.event_details || []);

  

    
    useEffect(() => {
      dispatch(resetProjectState())
      getUserRoles({scope: 'Organization'})
      getOrganisationMembersList()
      getRoles()
      dispatch(updateState({ production_event_id: null, can_upload:false}))

      dispatch(updateReviewState({open_request_changes_popup: false, open_video_accept_popup: false,}))
      dispatch(resetReviewState())
    // acceptMemberInvitation()
    }, [])

    useEffect(() => {
      if (commonReducer?.role_name === 'Admin') {
        getQuickTurnRequests();
      }
    }, [commonReducer?.role_name])

    // ?hidden=true is a deep link anyone could paste; the endpoints 403 for non-Admins,
    // so drop it rather than firing a request that is guaranteed to fail.
    useEffect(() => {
      if (hiddenOnly && commonReducer?.role_name && commonReducer.role_name !== 'Admin') {
        setHiddenOnly(false);
      }
    }, [hiddenOnly, commonReducer?.role_name, setHiddenOnly])
    
   

    // useEffect(()=>{
    //     dispatch(updateTeamState({selected_team: null}))
    //     getUserRoles(dispatch, navigate, permissionsReducer)
    //     getAllEvents(dispatch, navigate, {commonReducer});
    //     if(dropdownReducer.organisation_roles?.length === 0 || dropdownReducer.team_roles?.length === 0 || dropdownReducer.project_roles?.length === 0 ){
    //         getRoles(dispatch, navigate)
    //     }
      
    //     getAllTeams(dispatch, navigate)
    //     dispatch(updatePermissionState({org_role_id: teamsReducer?.organization_members?.find(mem => mem.id === commonReducer?.user_id)?.role?.id}))
    // },[])
   
    // useEffect(()=> {
    //     hasPermission(PERMISSION.ORGANISATION.MEMBER.VIEW) && viewOrganisationMember(dispatch, navigate)
    // },[permissionsReducer.permissions_master[PERMISSION.ORGANISATION.MEMBER.VIEW]])

    ////////////////////////////////////////permission ends//////////////////////////////////////

    //***********Rerenders the dashboard as soon as all the events are successfully fetched************ */
    // useEffect(()=> {
    //     setSearchedArray(commonReducer.combined_filter)
    // }, [commonReducer.combined_filter])

    useEffect(()=> {
        setSearchedArray(projectReducer?.org_projects_list)
    }, [projectReducer?.org_projects_list])



    useEffect(()=> {
        setMembers(teamsReducer?.organization_members)
        dispatch(updatePermissionState({org_role_id: teamsReducer?.organization_members?.find(mem => mem.id === commonReducer?.user_id)?.role?.id}))
    }, [teamsReducer?.organization_members])

   

    const onSearch = (event) => {
        setSearchString(event.target.value);
        if (projectReducer?.org_projects_list?.length > 0) {
            const temp = projectReducer?.org_projects_list?.filter((searchedEvent) => {
                if (event.target.value == "") {
                    return searchedEvent;
                } else if (
                    searchedEvent?.name
                        ?.toLowerCase()
                        ?.includes(event.target.value.toLocaleLowerCase())
                ) {
                    return searchedEvent;
                } else if (
                    searchedEvent?.event_type?.name
                        ?.toLowerCase()
                        ?.includes(event.target.value.toLocaleLowerCase())
                ) {
                    return searchedEvent;
                } else if (
                    timeStampToString(searchedEvent?.start_date)
                        ?.toLowerCase()
                        ?.includes(event.target.value.toLocaleLowerCase())
                ) {
                    return searchedEvent;
                } else if (
                    timeStampToString(searchedEvent?.editor_start_date)
                        ?.toLowerCase()
                        ?.includes(event.target.value.toLocaleLowerCase())
                )
                    return searchedEvent;
            });
            setSearchedArray(temp);
        }
    }

    //***********************LOGIC FOR CLICKS ON EVENT CARDS******************************************** */
    // Where the project detail screen should send the user on Back. Carrying the full
    // board URL (filters included) is what keeps an editor's project list intact across
    // Editor -> Project -> Back, instead of dropping the user on the unfiltered board.
    const boardReturnTo = `${location.pathname}${location.search || ''}`;

    const onEventClick = useCallback((event) => {
        dispatch(setSnackbar({type:'error', flag:false, message: 'You do not have permission to access this project currently'}))
        // Editors may open projects in any stage (a "editing not started" view is shown
        // for Production-stage projects). QC is still blocked from the Production stage.
        if(commonReducer?.role_name === 'QC' && event.status_type_order < 2){
            // pre-editing phase — blocked for QC
        } else {
            const canUpload = event?.flag?.can_upload ?? event?.can_upload;
            dispatch(updateState({ production_event_id: event?.id, can_upload: canUpload }));
            dispatch(updateReviewState({ can_upload: canUpload }));
            dispatch(updateProjectState({ event_organisation_name: event?.organisation_name ?? null, event_tags: Array.isArray(event?.tags) ? event.tags : [], event_video_length: event?.video_length ?? null, event_video_orientation: event?.video_orientation ?? null }));
            navigate(`/completedevent/${event?.organisation_id}/${event?.id}`, { state: { due_date: event?.due_date, returnTo: boardReturnTo } })
        }
    }, [commonReducer?.role_name, dispatch, navigate, boardReturnTo]);


    return <AuthLayout sx={{ padding: '2% 3.2% 2.1% 2.2%' }} isFetchingNextPageEvents={isFetchingNextPage}>
        <Box gap={2} className='flex row a-center' sx={{ px: {xs:1, sm:3}, justifyContent:'space-between' , pt: isMobileView && 1.5}} >
              <Box textAlign='center' sx={{  width:{xs:'20%', md:'11%'}  }} >        
                          <img src={luciLogo}  width='100%' onClick={()=> dispatch(updateState({open_drawer_org_list: true}))}/>  
                      </Box>
            <CustomUserCard />
        </Box>
        <Box className='flex row justify-center align-center'>

            {/* Left sidebar — list view only (disabled)
            {view === 'list' && (
              <Box id="left" className='flex col' sx={{ maxWidth: { xs: '160px', sm:'28%',md: '23%', lg: '21%', xl: '22%' }, marginTop:'15px', height:{xs:'80vh',md:'85vh', lg:'82vh'}}} >
                <AllOrganizationsCard setSelectedOrganisation={setSelectedOrganisation} selectedOrganisation={selectedOrganisation} />
              </Box>
            )}
            */}

            <Box id="right" width='100%' minWidth='300px' ml={0}>

                {/* List view only: org name + back button (disabled)
                {view === 'list' && selectedOrganisation?.name && (
                  <Box sx={{ marginTop: {xs: '15px', md: '30px', lg:'35px', xl:'35px'}, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Button
                      size='small'
                      variant='text'
                      startIcon={<ArrowBackIcon sx={{ fontSize: {xs:'15px !important', md:'17px !important', lg:'20px !important', xl:'24px !important'}, fontWeight: 900, strokeWidth: 2, stroke: 'currentColor' }} />}
                      onClick={() => setSelectedOrganisation('')}
                      sx={{
                        textTransform: 'none',
                        fontSize: {xs:'12px', sm:'13px', md:'14px', lg:'15px', xl:'18px'},
                        fontFamily: 'Rubik',
                        fontWeight: 600,
                        borderRadius: '6px',
                        py: {xs: 0.3, xl: 0.6},
                        px: {xs: 1, xl: 1.5},
                        color: 'rgba(0,0,0,0.65)',
                        alignSelf: 'flex-start',
                        '&:hover': { color: 'primary.main', backgroundColor: 'transparent' }
                      }}
                    >
                      All Projects
                    </Button>
                    <Typography sx={{fontSize:{xs:'14px',sm:'14px',md:'16px',lg:'20px',xl:'24px'}, fontWeight:600, letterSpacing:0, fontFamily:'Rubik', textAlign:'center', width:'100%'}}>{selectedOrganisation?.name}</Typography>
                  </Box>
                )}
                */}

                {/* List toolbar (disabled — restore when re-enabling list view)
                {view === 'list' && (
                  <Box width='100%' className='flex row j-between' sx={{ marginTop: '10px', marginBottom: {xs: '12px', md: '15px', lg:'20px', xl:'30px'}}}>
                    <Box id="search" sx={{flex: 1}}>
                      <Input
                        value={searchString}
                        onChange={onSearch}
                        sx={{ borderBottom: 2, borderColor: "#333333", input: { fontSize: { xs: '12px', md: '13px', lg: '14px', xl: '20px' }, fontWeight: 400, color: "#000000" } }}
                        placeholder="Search"
                        startAdornment={
                          <IconButton sx={{paddingBottom:1, fontSize: {xs:'12px',md:'14px',lg:'17px',xl:'24px'}, '& .MuiSvgIcon-root':{fontSize:{xs:'12px',md:'14px',lg:'17px',xl:'24px'}}, paddingRight:2}}>
                            <SearchIcon style={{ color: "#000000" }} />
                          </IconButton>
                        }
                      />
                    </Box>
                    <Box sx={{display:'flex', justifyContent:'end', alignItems:'center', cursor:'pointer'}} gap={{xs:0.5,sm:0.7, md:0.9, lg:1.2, xl:1.4}} pr={1}>
                      <EventStatusFilter sortByOptions={eventStatusFilterOptions} selectedSortbyValue={selectedEventStatusValue} setSelectedSortbyValue={setSelectedEventStatusValue} menuTitle="Event Status" selectedFlag={selectedFlag} setSelectedFlag={setSelectedFlag} />
                      <EventTypeFilter sortByOptions={eventSortOptions} selectedProjectTypeValue={selectedProjectTypeValue} setSelectedProjectTypeValue={setSelectedProjectTypeValue} setSelectedProjectTypeIds={setSelectedProjectTypeIds} selectedProjectTypeIds={selectedProjectTypeIds} />
                      <CustomSortOptions sortByOptions={eventSortOptions} selectedSortbyValue={selectedSortbyValue} setSelectedSortbyValue={setSelectedSortbyValue} menuTitle="Sort By" />
                      {isAdmin && <EditorFilterSelect value={selectedEditorId} onChange={setSelectedEditorId} editors={editorList} />}
                      <DueDateFilterSelect value={dueDateFilter} onChange={setDueDateFilter} />
                      <ViewToggle active={view} onChange={handleViewChange} />
                    </Box>
                  </Box>
                )}
                */}

                {/* Board toolbar — org dropdown | search | filters */}
                <Box sx={{ display: 'flex', alignItems: 'center', mt: { xs: 1.5, md: 2, lg: 2.5 }, mb: {xs: '12px', md: '15px', lg:'20px', xl:'30px'} }}>
                  <Box id="board-search" sx={{ flex: 1, mx: { xs: 1, md: 2 } }}>
                    <Input
                      value={searchString}
                      onChange={onSearch}
                      sx={{
                        borderBottom: 2,
                        borderColor: "#333333",
                        input: { fontSize: { xs: '12px', md: '13px', lg: '14px', xl: '20px' }, fontWeight: 400, color: "#000000" },
                      }}
                      placeholder="Search"
                      startAdornment={
                        <IconButton sx={{paddingBottom:1, fontSize: {xs:'12px',md:'14px',lg:'17px',xl:'24px'}, '& .MuiSvgIcon-root':{fontSize:{xs:'12px',md:'14px',lg:'17px',xl:'24px'}}, paddingRight:2}}>
                          <SearchIcon style={{ color: "#000000" }} />
                        </IconButton>
                      }
                    />
                  </Box>
                  <Box sx={{display:'flex', alignItems:'center', justifyContent:'flex-end', flexWrap:'wrap'}} gap={{xs:0.5,sm:0.7, md:0.9, lg:1.2, xl:1.4}}>
                    <OrgSelectorDropdown
                      selectedOrganisation={selectedOrganisation}
                      setSelectedOrganisation={setSelectedOrganisation}
                    />
                    <EventTypeFilterSelect value={selectedEventTypeId} onChange={setSelectedEventTypeId} eventTypes={eventTypes} />
                    {(isAdmin || commonReducer?.role_name === 'QC') && (
                      <EditorFilterSelect value={selectedEditorId} onChange={setSelectedEditorId} editors={editorList} />
                    )}
                    <DueDateFilterSelect value={dueWithinHours} onChange={setDueWithinHours} />
                    <QuickTurnToggle value={quickTurn} onChange={setQuickTurn} />
                    {isPharoahAdmin && <HiddenFilterToggle value={hiddenOnly} onChange={setHiddenOnly} />}
                    {/* ViewToggle disabled — board only for now
                    <ViewToggle active={view} onChange={handleViewChange} />
                    */}
                  </Box>
                </Box>

                {/* Board content — measured to fill exactly to the bottom of the viewport
                    (minus a small margin) so columns stay capped in view and scroll
                    internally, instead of a guessed vh that overflows or leaves a gap.
                    Bounded on mobile too, since below 600px KanbanBoard shows either a
                    single tab-selected column (needs a fixed height for its own
                    scroll/lazy-load) or the "All" tab stacking every column —
                    overflow:auto lets that stack scroll within this box rather than
                    being clipped. */}
                <Box ref={boardContainerRef} sx={{ height: boardContainerHeight ? `${boardContainerHeight}px` : '60vh', overflow: 'auto' }}>
                  <KanbanBoard orgId={selectedOrganisation?.id} onCardClick={onEventClick} name={debouncedSearch || undefined} dueWithinHours={dueWithinHours || undefined} editorId={selectedEditorId || undefined} eventTypeId={selectedEventTypeId || undefined} quickTurn={quickTurn || undefined} hidden={(isPharoahAdmin && hiddenOnly) || undefined} />
                </Box>

                {/* List content (disabled — restore when re-enabling list view)
                <Box id="events" className='flex row f-wrap f-start a-start' sx={{ height: { xs: '71vh', sm: '67vh', md: '73vh', lg: '67vh', xl: '66vh' }, overflowY: "scroll", whiteSpace: 'nowrap', alignContent: 'flex-start', backgroundColor:'transparent', scrollbarWidth: 'none', msOverflowStyle: 'none', '&::-webkit-scrollbar': {display : 'none'} }}>
                  {sortedEvents?.length == 0
                    ? <Box className='flex col j-center a-center' sx={{overflowY: "initial", whiteSpace: 'normal'}} height='100%' width='100%'>
                        <Typography sx={{fontSize: 30, color: '#878887', fontWeight: 300, textAlign: 'center', mt:3}}>No Lucihub Project to display.<br/></Typography>
                      </Box>
                    : sortedEvents?.map((e, index) => {
                        const isLast = index === sortedEvents.length - 1;
                        return (
                          (projectReducer?.is_org_projects_loading || commonReducer?.is_loading || isLoading)
                            ? <CustomCard sx={{backgroundColor:'#eeeeee !important', width: { xs: '100%', md: 'calc(50% - 16px)', lg: 'calc(33% - 16px)', xl: 'calc(33% - 16px)' }, height:{xs:'125px', xl:'180px'}, borderRadius:'5px', mt:2.5, mr:2, opacity: 0.5, display:'flex', flexDirection:'column', alignItems:'space-evenly'}}>
                                <Skeleton variant="rounded" animation='pulse' height='15px' width='40%' sx={{mt:{xs:1, xl:3}, ml:2}}/>
                                <Skeleton variant="rounded" animation='pulse' height='18px' width='60%' sx={{mt:{xs:2, xl:3}, ml:2}}/>
                                <Skeleton variant="rounded" animation='pulse' height='18px' width='90%' sx={{mt:{xs:2, xl:3}, ml:2}}/>
                                <Skeleton variant="rounded" animation='pulse' height='18px' width='18px' sx={{ml:2, mt:{xs:1, xl:3}}}/>
                              </CustomCard>
                            : <Box sx={{ width: { xs: '100%', md: 'calc(50% - 16px)', lg: 'calc(33% - 16px)', xl: 'calc(33% - 30px)' }, mt: 2, mr:2}} ref={isLast ? lastElementRef : null}>
                                <CustomTooltip title={(e.status_type_order < 2 || (commonReducer?.role_name === 'Editor' && e.status_type_order === 2)) ? "Editing not started yet" : null} PopperProps={{modifiers: [{name: "offset", options: {offset: [-35, -4]}}]}}>
                                  <EventCard onClick={() => onEventClick(e)} event={e} sx={{cursor: (commonReducer?.role_name === 'Admin' || (e.status_type_order > 1 && !(commonReducer?.role_name === 'Editor' && e.status_type_order === 2))) && "pointer"}} />
                                </CustomTooltip>
                              </Box>
                        );
                      })
                  }
                  {isFetchingNextPage && <Box sx={{width:'100%', height:'60px',display:'flex', justifyContent:'center', alignItems:'center', gap:2}}><p style={{textAlign:'center'}}>Loading more...</p><CircularProgress color="primary" size='30px' variant="indeterminate" /></Box>}
                  {!hasNextPage && <Box sx={{width:'100%', height:'40px'}}><p style={{textAlign:'center'}}>No more projects</p></Box>}
                </Box>
                */}
            </Box>
        </Box>
    
        {
            commonReducer.event_delete_popup == true && <DeleteConfirmationPopup deleteProject = {deleteProject} status = {deleteEventStatus}/>
            
        }
         {
            commonReducer.delete_decline_popup == true && <DeleteDeclinePopup/>
            
        }
        {createEventReducer.edit_decline_popup == true && <DeclineEditProjectPopup/>}

        {teamsReducer.open_create_team_form == true && <TeamCreationDrawer />}

        {teamsReducer.delete_team_popup == true && <DeleteTeamPopup/>}

        {teamsReducer.rename_team_popup == true && <RenameTeamPopup/>}

        {/* {teamsReducer.invite_team_members_popup == true && <InviteMembersPopup members={members} options={dropdownReducer?.organisation_roles} roleNameFromId={getRoleNamesFromIds}/>} */}

        {commonReducer.invite_org_members_popup == true && <InviteOrganisationMembersPopup options={dropdownReducer?.organisation_roles}/>}

        {teamsReducer.remove_member_confirmation_popup == true && <RemoveOrganisationMemberConfirmationPopup/>}

         {commonReducer?.change_member_role_confirmation_popup == true && <ChangeMemberRoleConfirmationPopup/>}

        {/* {teamsReducer.assign_role_popup == true && <AssignRolePopup/>} */}

        {teamsReducer.assign_role_popup == true && <AssignAdminRolePopup/>}

        {commonReducer.view_members_popup == true && <ViewOrganisationMembersPopup  options={dropdownReducer?.organisation_roles}/>}
        {projectReducer.view_project_members_popup == true && <ViewProjectMembersPopup />}
        {commonReducer?.editing_not_started_popup && <EditingNotStartedPopup/>}

        <PharoahVisibilityUndoSnackbar />

        {/* {createEventReducer?.open_backdrop_project_creation === true && <BackdropCreateProject />} */}

    </AuthLayout>
}
export default Dashboard;